import { default as _91_46_46_46cms_93klhDdGXFxUMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93IjSorQGtWbMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexpHzLjky9JQMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93XacGkFsimGMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/akcii/[...slug].vue?macro=true";
import { default as indexAKiQJLNtdNMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93lPHL5ajuPWMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/articles/[...slug].vue?macro=true";
import { default as indexZFU54aCgCJMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/articles/index.vue?macro=true";
import { default as index7fli88roJeMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/authorization/index.vue?macro=true";
import { default as indexiCyU3CaIkHMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93DIlT2hPQwvMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93zJoaJmzoVhMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/catalog/[...slug].vue?macro=true";
import { default as index6pk2JGSL5XMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93CZCmHlUz3vMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultuHLrMhOb4wMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/catalogsearch/result.vue?macro=true";
import { default as indexqwoQ5l7vOMMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93GV5dztNvcyMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93tLsueqpTBYMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/fabriki/[...slug].vue?macro=true";
import { default as indexWxYUyII31pMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93vHXRZqYdLYMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_93CLygNf423wMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/product/[...slug].vue?macro=true";
import { default as indexxcxwvnf0l1Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/profile/index.vue?macro=true";
import { default as indexQ9B6JoQ4DUMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/profile/orders/index.vue?macro=true";
import { default as index1Hdpgl2O7rMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93IdeJWeNCevMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/sets/[...slug].vue?macro=true";
import { default as indexYDtEBZ2IGWMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93klhDdGXFxUMeta?.name ?? "cms",
    path: _91_46_46_46cms_93klhDdGXFxUMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93klhDdGXFxUMeta || {},
    alias: _91_46_46_46cms_93klhDdGXFxUMeta?.alias || [],
    redirect: _91_46_46_46cms_93klhDdGXFxUMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93IjSorQGtWbMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93IjSorQGtWbMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93IjSorQGtWbMeta || {},
    alias: _91_46_46_46slug_93IjSorQGtWbMeta?.alias || [],
    redirect: _91_46_46_46slug_93IjSorQGtWbMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexpHzLjky9JQMeta?.name ?? "3d-projects",
    path: indexpHzLjky9JQMeta?.path ?? "/3d-projects",
    meta: indexpHzLjky9JQMeta || {},
    alias: indexpHzLjky9JQMeta?.alias || [],
    redirect: indexpHzLjky9JQMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93XacGkFsimGMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93XacGkFsimGMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93XacGkFsimGMeta || {},
    alias: _91_46_46_46slug_93XacGkFsimGMeta?.alias || [],
    redirect: _91_46_46_46slug_93XacGkFsimGMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexAKiQJLNtdNMeta?.name ?? "akcii",
    path: indexAKiQJLNtdNMeta?.path ?? "/akcii",
    meta: indexAKiQJLNtdNMeta || {},
    alias: indexAKiQJLNtdNMeta?.alias || [],
    redirect: indexAKiQJLNtdNMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93lPHL5ajuPWMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93lPHL5ajuPWMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93lPHL5ajuPWMeta || {},
    alias: _91_46_46_46slug_93lPHL5ajuPWMeta?.alias || [],
    redirect: _91_46_46_46slug_93lPHL5ajuPWMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexZFU54aCgCJMeta?.name ?? "articles",
    path: indexZFU54aCgCJMeta?.path ?? "/articles",
    meta: indexZFU54aCgCJMeta || {},
    alias: indexZFU54aCgCJMeta?.alias || [],
    redirect: indexZFU54aCgCJMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: index7fli88roJeMeta?.name ?? "authorization",
    path: index7fli88roJeMeta?.path ?? "/authorization",
    meta: index7fli88roJeMeta || {},
    alias: index7fli88roJeMeta?.alias || [],
    redirect: index7fli88roJeMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexiCyU3CaIkHMeta?.name ?? "cart",
    path: indexiCyU3CaIkHMeta?.path ?? "/cart",
    meta: indexiCyU3CaIkHMeta || {},
    alias: indexiCyU3CaIkHMeta?.alias || [],
    redirect: indexiCyU3CaIkHMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93DIlT2hPQwvMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93DIlT2hPQwvMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93DIlT2hPQwvMeta || {},
    alias: _91_46_46_46id_93DIlT2hPQwvMeta?.alias || [],
    redirect: _91_46_46_46id_93DIlT2hPQwvMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93zJoaJmzoVhMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93zJoaJmzoVhMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93zJoaJmzoVhMeta || {},
    alias: _91_46_46_46slug_93zJoaJmzoVhMeta?.alias || [],
    redirect: _91_46_46_46slug_93zJoaJmzoVhMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index6pk2JGSL5XMeta?.name ?? "catalog",
    path: index6pk2JGSL5XMeta?.path ?? "/catalog",
    meta: index6pk2JGSL5XMeta || {},
    alias: index6pk2JGSL5XMeta?.alias || [],
    redirect: index6pk2JGSL5XMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93CZCmHlUz3vMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93CZCmHlUz3vMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93CZCmHlUz3vMeta || {},
    alias: _91_46_46_46slug_93CZCmHlUz3vMeta?.alias || [],
    redirect: _91_46_46_46slug_93CZCmHlUz3vMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultuHLrMhOb4wMeta?.name ?? "catalogsearch-result",
    path: resultuHLrMhOb4wMeta?.path ?? "/catalogsearch/result",
    meta: resultuHLrMhOb4wMeta || {},
    alias: resultuHLrMhOb4wMeta?.alias || [],
    redirect: resultuHLrMhOb4wMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexqwoQ5l7vOMMeta?.name ?? "clear-page-slider",
    path: indexqwoQ5l7vOMMeta?.path ?? "/clear-page-slider",
    meta: indexqwoQ5l7vOMMeta || {},
    alias: indexqwoQ5l7vOMMeta?.alias || [],
    redirect: indexqwoQ5l7vOMMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93GV5dztNvcyMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93GV5dztNvcyMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93GV5dztNvcyMeta || {},
    alias: _91_46_46_46slug_93GV5dztNvcyMeta?.alias || [],
    redirect: _91_46_46_46slug_93GV5dztNvcyMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93tLsueqpTBYMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93tLsueqpTBYMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93tLsueqpTBYMeta || {},
    alias: _91_46_46_46slug_93tLsueqpTBYMeta?.alias || [],
    redirect: _91_46_46_46slug_93tLsueqpTBYMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexWxYUyII31pMeta?.name ?? "fabriki",
    path: indexWxYUyII31pMeta?.path ?? "/fabriki",
    meta: indexWxYUyII31pMeta || {},
    alias: indexWxYUyII31pMeta?.alias || [],
    redirect: indexWxYUyII31pMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93vHXRZqYdLYMeta?.name ?? "order-status-hash",
    path: _91hash_93vHXRZqYdLYMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_93vHXRZqYdLYMeta || {},
    alias: _91hash_93vHXRZqYdLYMeta?.alias || [],
    redirect: _91hash_93vHXRZqYdLYMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93CLygNf423wMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93CLygNf423wMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93CLygNf423wMeta || {},
    alias: _91_46_46_46slug_93CLygNf423wMeta?.alias || [],
    redirect: _91_46_46_46slug_93CLygNf423wMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexxcxwvnf0l1Meta?.name ?? "profile",
    path: indexxcxwvnf0l1Meta?.path ?? "/profile",
    meta: indexxcxwvnf0l1Meta || {},
    alias: indexxcxwvnf0l1Meta?.alias || [],
    redirect: indexxcxwvnf0l1Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexQ9B6JoQ4DUMeta?.name ?? "profile-orders",
    path: indexQ9B6JoQ4DUMeta?.path ?? "/profile/orders",
    meta: indexQ9B6JoQ4DUMeta || {},
    alias: indexQ9B6JoQ4DUMeta?.alias || [],
    redirect: indexQ9B6JoQ4DUMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index1Hdpgl2O7rMeta?.name ?? "recently",
    path: index1Hdpgl2O7rMeta?.path ?? "/recently",
    meta: index1Hdpgl2O7rMeta || {},
    alias: index1Hdpgl2O7rMeta?.alias || [],
    redirect: index1Hdpgl2O7rMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93IdeJWeNCevMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93IdeJWeNCevMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93IdeJWeNCevMeta || {},
    alias: _91_46_46_46slug_93IdeJWeNCevMeta?.alias || [],
    redirect: _91_46_46_46slug_93IdeJWeNCevMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexYDtEBZ2IGWMeta?.name ?? "wishlist",
    path: indexYDtEBZ2IGWMeta?.path ?? "/wishlist",
    meta: indexYDtEBZ2IGWMeta || {},
    alias: indexYDtEBZ2IGWMeta?.alias || [],
    redirect: indexYDtEBZ2IGWMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/pages/wishlist/index.vue").then(m => m.default || m)
  }
]